export default class AnchoredScroll {
	constructor() {
		this.bindUIActions();
	}
	bindUIActions() {
		window.addEventListener('DOMContentLoaded', () => {
			const observer = new IntersectionObserver(entries => {
				entries.forEach(entry => {
					const id = entry.target.getAttribute('id');
					if (entry.intersectionRatio > 0) {
						$(`.js-anchored-scroll-nav li a[href="#${id}"]`).parent().addClass('active');
					} else {
						$(`.js-anchored-scroll-nav li a[href="#${id}"]`).parent().removeClass('active');
					}
				});
			});
			// Track all sections that have an `id` applied
			document.querySelectorAll('.anchored-section').forEach((section) => {
				observer.observe(section);
			});
		});
	}
};
new AnchoredScroll();
